module.exports = __webpack_public_path__ + "img/success.d4b5a259.png";